import { NgForm } from "@angular/forms";
import { Component, Input, ViewChild } from "@angular/core";
import { ModalDirective } from "ngx-bootstrap";
import { CBP7501 } from "../../../../objects/documents/CBP7501";
import { ValidationPatterns } from "../../../../common/helpers/ValidationPatterns";

@Component({
    selector: 'third-block-7501',
    templateUrl: 'third-block-7501.component.html',
    moduleId: module.id.toString()
})

export class ThirdBlock7501Component{
    @Input()
    public document: CBP7501;

    @ViewChild("thirdBlockForm")
    public thirdBlockForm: NgForm;

    public numberPatternHelper = ValidationPatterns;

    public submitFormAndValidity(): boolean{
        this.thirdBlockForm.onSubmit(null);

        return this.isFormValid();
    }

    public isFormValid(): boolean{
        return this.thirdBlockForm.valid;
    }

}


// WEBPACK FOOTER //
// ./app/components/export-documents/cbp-7501/document-blocks/third-block-7501.component.ts